/** Both review pages keep their selected tab and document return path in the URL. */
export function validateReviewSearch(search: Record<string, unknown>): {
  tab?: "changes";
  compose?: "inspector";
  fromPolicy?: string;
} {
  return {
    ...(typeof search.fromPolicy === "string" && search.fromPolicy.length <= 200
      ? { fromPolicy: search.fromPolicy }
      : {}),
    ...(search.tab === "changes" ? { tab: "changes" as const } : {}),
    ...(search.compose === "inspector" ? { compose: "inspector" as const } : {}),
  };
}
